<template>
  <DataView
    :context="context"
    :defaultCheckedCols="checkedCols"
    :defaultCheckedMetrics="checkedMetrics"
    :plotMetrics="plotMetrics"
    :fixedColumns="fixedColumns"
    :initialTemplate="template"
    :defaultSort="defaultSort"
    :back="parseInt(back)"
  ></DataView>
</template>

<script>
import DataView from "@/components/DataView";
export default {
  name: "Audience",
  components: { DataView },
  props : {
    template: {
      default: "Default",
      type:  String
    },
    back: {
      default: "0",
      type:  String
    }
  },
  data() {
    return {
      context: "audience",
      defaultSort: "Button Clicks",
      checkedCols: ["AdNetwork"],
      checkedMetrics: [
        "Active Session Duration",
        "Button Clicks",
        "Link Clicks",
        "Image Clicks",
        "Input Clicks",
        "Mouse Scrolled Visits",
        "Scroll Depth 25%",
        "Scroll Depth 50%",
        "Scroll Depth 75%",
        "Scroll Depth 100%",
      ],
      plotMetrics: ["Button Clicks", "Link Clicks"],
      fixedColumns: false,
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Audience.vue